<!-- LOADING OVERLAY -->
<div *ngIf="isSaving" class="fixed inset-0 flex items-center justify-center z-[100] backdrop-blur-sm bg-white/30">
  <i class="fas fa-spinner fa-spin text-5xl md:text-6xl text-[#006269]"></i>
</div>

<div class="flex flex-col min-h-screen w-full bg-gray-100 font-sans">
  <!-- MAIN SCROLLABLE AREA -->
  <main class="flex-1 bg-white">
    <div class="w-full max-w-8xl mx-auto px-4 py-6 md:px-8 md:py-12 lg:py-16">

      <!-- Header Section -->
      <div class="border-b border-gray-100 pb-4 mb-8">
        <h1 class="text-xl md:text-2xl lg:text-3xl font-black text-gray-800 uppercase tracking-tight">Upload Purchase
          Bill</h1>
        <p class="text-[10px] md:text-xs text-gray-400 mt-1 uppercase tracking-widest">Enter details and attach document
          below</p>
      </div>

      <!-- Grid Layout: Stacks on mobile (1 column), splits on medium screens+ (2 columns) -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-10">

        <!-- SECTION 1: FINANCIALS (Emerald Lite) -->
        <div class="bg-emerald-50/50 p-5 md:p-8 rounded-2xl border border-emerald-100 shadow-sm space-y-5">
          <h3
            class="text-emerald-700 font-bold text-[11px] md:text-xs uppercase tracking-widest flex items-center gap-2">
            <i class="fas fa-calendar-alt"></i> Financials
          </h3>
          <div class="space-y-4">
            <div class="flex flex-col">
              <label class="text-[10px] md:text-[11px] font-bold text-gray-700 uppercase mb-1">Purchase Date</label>
              <input type="date" [(ngModel)]="purchaseData.date"
                class="w-full border-gray-300 rounded-xl p-3 text-sm focus:border-emerald-500 outline-none bg-white shadow-sm appearance-none">
            </div>
            <div class="flex flex-col">
              <label class="text-[10px] md:text-[11px] font-bold text-gray-700 uppercase mb-1">Total Bill Amount
                (₹)</label>
              <input type="number" [(ngModel)]="purchaseData.amount" placeholder="0.00"
                class="w-full no-spinner border-gray-300 rounded-xl p-3 text-xl md:text-2xl font-black text-[#006269] focus:border-emerald-500 outline-none shadow-sm">
            </div>
            <div class="flex flex-col">
              <label class="text-[10px] md:text-[11px] font-bold text-gray-700 uppercase mb-1">Select Expense
                Account</label>
              <select [(ngModel)]="purchaseData.expense_account_id"
                class="w-full border-gray-300 rounded-xl p-3 text-sm focus:border-emerald-500 outline-none bg-white shadow-sm appearance-none">
                <option [ngValue]="null" disabled>Select an account</option>
                <option *ngFor="let acc of expenseAccounts" [ngValue]="acc.acc_id">
                  {{ acc.acc_user_acc }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <!-- SECTION 2: FILE UPLOAD (Amber Lite) -->
        <div class="bg-amber-50/50 p-5 md:p-8 rounded-2xl border border-amber-100 shadow-sm space-y-5">
          <h3 class="text-amber-700 font-bold text-[11px] md:text-xs uppercase tracking-widest flex items-center gap-2">
            <i class="fas fa-cloud-upload-alt"></i> Attach Document
          </h3>
          <div class="relative group h-full">
            <label
              class="flex flex-col items-center justify-center w-full min-h-[160px] md:min-h-[180px] border-2 border-amber-300 border-dashed rounded-2xl cursor-pointer bg-white/50 hover:bg-white transition-all shadow-sm">
              <div class="flex flex-col items-center justify-center py-6 text-center">
                <i class="fas fa-file-pdf text-3xl md:text-4xl text-amber-500 mb-2" *ngIf="!fileName"></i>
                <i class="fas fa-file-alt text-3xl md:text-4xl text-emerald-600 mb-2" *ngIf="fileName"></i>

                <p class="text-xs md:text-sm text-gray-600 font-bold px-4" *ngIf="!fileName">Click to browse file</p>
                <p class="text-xs md:text-sm text-emerald-700 font-black truncate max-w-[250px] px-6" *ngIf="fileName">
                  {{ fileName }}</p>

                <p class="text-[9px] md:text-[10px] text-gray-400 mt-2 uppercase px-4" *ngIf="!fileName">PDF, Images, or
                  Documents</p>
              </div>
              <input type="file" class="hidden" (change)="onFileSelected($event)" />
            </label>
          </div>
        </div>
      </div>

      <!-- SAVE BUTTON SECTION -->
      <div class="mt-10 md:mt-12">
        <button (click)="submitPurchase()" [disabled]="isSaving"
          class="w-full py-4 md:py-5 bg-[#006269] text-white font-black rounded-2xl shadow-xl hover:bg-black disabled:bg-gray-400 active:scale-[0.98] transition-all uppercase tracking-[0.2em] text-xs md:text-sm flex items-center justify-center gap-3">
          <i class="fas" [ngClass]="isSaving ? 'fa-spinner fa-spin' : 'fa-check-circle text-cyan-300 text-lg'"></i>
          {{ isSaving ? 'Saving Process...' : 'Save Purchase Bill' }}
        </button>
        <p class="text-center text-[9px] md:text-[10px] text-gray-400 mt-5 uppercase tracking-widest">Ensuring secure
          storage for Meena Silver & Co Records</p>
      </div>

    </div>
  </main>
</div>